"use strict";

import angular from "angular";

import { setMonth, setYear } from "date-fns";
import _ from "lodash";
import { AvailablePeriod } from "../../../presentation/services/AvailablePeriod/AvailablePeriod";
import * as DateUtils from "../../../utils/date/date";
import template from "./period-select.component.html";
import "./period-select.component.scss";

("use strict");

class PeriodSelectComponent {
    constructor() {
        this.AvailablePeriod = new AvailablePeriod();
        this.yearSelected = "";
        this.monthSelected = "";
        this.quarterlySelected = "";
        this.semesterSelected = "";
        this.yearSelectedStart = "";
        this.quarterlySelectedStart = "";
        this.semesterSelectedStart = "";
        this.monthSelectedStart = "";

        this.years = [];
    }

    $onInit() {
        this._setYears();
        this._setMonths();

        this._setViewConfigs(this.currentPeriod.period);
        if (this.currentPeriod.startDate)
            this._setViewConfigsStart(this.currentPeriod.period);
    }

    $onChanges(changes) {
        if (changes.available?.previousValue) {
            this._setYears();
        }
        if (typeof changes.triggerClearInputs?.previousValue != "object") {
            this._clearInputs();
        }
    }

    _clearInputs() {
        this.yearSelected = "";
        this.monthSelected = "";
        this.quarterlySelected = "";
        this.semesterSelected = "";
        this.yearSelectedStart = "";
        this.quarterlySelectedStart = "";
        this.semesterSelectedStart = "";
        this.monthSelectedStart = "";
    }

    _setViewConfigs(period) {
        const month = this.currentPeriod.allMonths
            ? 12
            : this.currentPeriod.date.getUTCMonth();
        const year = this.currentPeriod.date.getUTCFullYear();
        const periods = {
            monthly: () => {
                this.yearSelected = year;
                this.monthSelected = this.allowAllMonths ? month + 1 : month;
            },
            quarterly: () => {
                this.yearSelected = year;
                this.quarterlySelected = month;
            },
            semester: () => {
                this.yearSelected = year;
                this.semesterSelected = month;
            },
            yearly: () => {
                this.yearSelected = year;
            }
        };

        if (periods[period]) periods[period]();
    }

    _setViewConfigsStart(period) {
        const monthStart = this.currentPeriod.startDate.getUTCMonth();
        const yearStart = this.currentPeriod.startDate.getUTCFullYear();
        const periods = {
            monthly: () => {
                this.yearSelectedStart = yearStart;
                this.monthSelectedStart = this.allowAllMonths
                    ? monthStart + 1
                    : monthStart;
            },
            quarterly: () => {
                this.yearSelectedStart = yearStart;
                this.quarterlySelectedStart = monthStart;
            },
            semester: () => {
                this.yearSelectedStart = yearStart;
                this.semesterSelectedStart = monthStart;
            },
            yearly: () => {
                this.yearSelectedStart = yearStart;
            }
        };

        if (periods[period]) periods[period]();
    }

    onSelectYear(period, year) {
        const date = this.currentPeriod.date;
        this.currentPeriod.date = setYear(date, year);
        const periods = {
            monthly: () => {
                this.monthSelected = "";
            },
            quarterly: () => {
                this.quarterlySelected = "";
            },
            semester: () => {
                this.semesterSelected = "";
            },
            yearly: () => {
                this.currentPeriod.date = setMonth(this.currentPeriod.date, 11);
            }
        };
        if (periods[period]) periods[period]();
    }

    onSelectYearStart(period, year) {
        const date = this.currentPeriod.startDate;
        this.currentPeriod.startDate = setYear(date, year);
        const periods = {
            monthly: () => {
                this.monthSelectedStart = "";
            },
            quarterly: () => {
                this.quarterlySelectedStart = "";
            },
            semester: () => {
                this.semesterSelectedStart = "";
            },
            yearly: () => {
                this.currentPeriod.startDate = setMonth(
                    this.currentPeriod.startDate,
                    11
                );
            }
        };
        if (periods[period]) periods[period]();
    }

    onSelectMonth(month, ignoreAllMonths) {
        if (month === 0 && this.allowAllMonths) {
            this.currentPeriod.allMonths = true;
            return;
        } else if (this.allowAllMonths && !ignoreAllMonths) {
            month = month - 1;
        }
        this.currentPeriod.allMonths = false;
        const date = this.currentPeriod.date;
        this.currentPeriod.date = setMonth(date, month);
    }

    onSelectMonthStart(month, ignoreAllMonths) {
        const date = this.currentPeriod.startDate;
        this.currentPeriod.startDate = setMonth(date, month);
    }

    onSelectPeriod(period) {
        this.currentPeriod.period = period;
        if (period === "yearly") {
            this.currentPeriod.date = setMonth(this.currentPeriod.date, 11);
            this.currentPeriod.startDate = setMonth(
                this.currentPeriod.startDate,
                11
            );
        }
        this._setMonths();
    }

    _setYears() {
        if (!this.available?.length) return;
        const lastDate = _.last(this.available);
        const date = new Date(lastDate).toISOString();
        const lastYear = DateUtils.getFullYear(date);
        const years = DateUtils.years(2010, lastYear);
        this.years = years.reverse();
    }

    _setMonths() {
        const monthly = this.allowAllMonths
            ? ["Todos os meses", ...DateUtils.months()]
            : DateUtils.months();
        const periods = {
            monthly,
            quarterly: DateUtils.quarters(),
            semester: DateUtils.semesters()
        };
        if (periods[this.currentPeriod.period])
            this.months = periods[this.currentPeriod.period];
    }

    yearIsDisabled(year, period = this.currentPeriod.period) {
        return !this.AvailablePeriod.yearIsAvailable({
            available: this.available,
            year,
            period
        });
    }

    monthIsDisabled(
        month,
        period = this.currentPeriod.period,
        ignoreAllMonths
    ) {
        if (month === 0) return false;
        let _month = 0;
        if (this.allowAllMonths && !ignoreAllMonths) _month = Number(month);
        else _month = Number(month) + 1;
        return !this.AvailablePeriod.dateIsAvailable({
            available: this.available,
            year: this.yearSelected,
            month: _month,
            period
        });
    }

    monthIsDisabledStart(month, period = this.currentPeriod.period) {
        const _month = Number(month) + 1;
        return !this.AvailablePeriod.dateIsAvailable({
            available: this.available,
            year: this.yearSelectedStart,
            month: _month,
            period
        });
    }

    onFilter() {
        this.selectPeriod();
    }

    isDisabled(period = this.currentPeriod.period) {
        if (!this.yearSelected) return true;
        const periods = {
            monthly: () => {
                if (this.monthSelected === "") return true;
            },
            quarterly: () => {
                if (this.quarterlySelected === "") return true;
            },
            semester: () => {
                if (this.semesterSelected === "") return true;
            }
        };

        if (periods[period]) return periods[period]();
    }

    isDisabledStart(period = this.currentPeriod.period) {
        if (!this.yearSelected || !this.yearSelectedStart) return true;
        const periods = {
            monthly: () => {
                if (this.monthSelected === "" || this.monthSelectedStart === "")
                    return true;
            },
            quarterly: () => {
                if (
                    this.quarterlySelected === "" ||
                    this.quarterlySelectedStart === ""
                )
                    return true;
            },
            semester: () => {
                if (
                    this.semesterSelected === "" ||
                    this.semesterSelectedStart === ""
                )
                    return true;
            }
        };

        if (periods[period]) return periods[period]();
    }

    onClear() {
        this.buttonClear();
    }
}

export { PeriodSelectComponent };

PeriodSelectComponent.$inject = [];

const name = "periodSelectComponent";
const def = {
    bindings: {
        periods: "<",
        currentPeriod: "<",
        available: "<",
        selectPeriod: "&",
        triggerClearInputs: "<",
        allowAllMonths: "<",
        buttonClear: "&",
        goals: "<",
        periodsFilter: "<",
        comparationActive: "<"
    },
    controller: PeriodSelectComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
